import {BehaviorSubject} from "rxjs";
import {IMessageProvider, IProgressProvider} from "./PA.Core.IF.Basic";



export interface IColumnText {
    readonly LanguageCode: string,

    readonly Text: string,
    readonly ShortText: string,
    readonly Abbreviation: string,
    readonly Tooltip: string

    readonly FallbackName?: string
    readonly FallbackText?: IColumnText
}

export interface IMessageText {
    readonly LanguageCode: string,
    // Add any metadata
    readonly Message: string

    readonly FallbackText?: IMessageText
}

export interface ILanguageTextChangeEvent {
    Context: ILanguageTextServiceContext,
    EventType: string,
    DataObjects?: {Type: string, Id: string}[]
}


export interface ILanguageTextService {
    readonly LoadMessagesProvider: IMessageProvider
    readonly LoadProgressProvider: IProgressProvider

    createServiceContext(languageCd: string | string[]): ILanguageTextServiceContext
}


export interface ILanguageTextServiceContext {

    readonly LoadMessagesProvider: IMessageProvider
    readonly LoadProgressProvider: IProgressProvider

    //--
    readonly LanguageCd: string
    readonly LanguageTextService: ILanguageTextService



    //-- Setup, Sync
    setLanguage(sLanguageCode: string): void

    aliasTable(aliasId: string, sTableId: string, bPreload?: boolean): void
    aliasView(aliasId: string, sViewId: string, bPreload?: boolean): void
    aliasUIControl(aliasId: string, sUIControlId: string, bPreload?: boolean): void
    aliasUIView(aliasId: string, sUIViewId: string, bPreload?: boolean): void
    aliasResource(aliasId: string, sResourceId: string, bPreload?: boolean): void
    hasAlias(aliasId: string): boolean

    // Sync API
    // -- Get Operations, Sync, return undefined when unknown, queues otherwise, fires update
    getColumnText(dataObjectTypeId: string, dataObjectId: string, columnId: string): IColumnText
    getMessage(dataObjectTypeId: string, dataObjectId: string, messageId: string): IMessageText

    getAliasText(aliasId: string, columnId: string): IColumnText
    getAliasMessage(aliasId: string, messageId: string): IMessageText

    OnLanguageTextChanged: BehaviorSubject<ILanguageTextChangeEvent>

    // Async API
    // -- Get Operations, ASync, return Promise
    getColumnTextAsync(dataObjectTypeId: string, dataObjectId: string, columnId: string): Promise<IColumnText>
    getMessageAsync(dataObjectTypeId: string, dataObjectId: string, messageId: string): Promise<IMessageText>

    getAliasTextAsync(aliasId: string, columnId: string): Promise<IColumnText>
    getAliasMessageAsync(aliasId: string, messageId: string): Promise<IMessageText>

}

export enum DataObjectType {
    Table="Table",
    View="View",
    UIControl="UIControl",
    UIView="UIView",
    Resource="Resource",
    BO="BO",
    Process="Process"
}